import { ofType } from "redux-observable";
import { ajax } from "rxjs/ajax";
import { of } from "rxjs";
import { mergeMap, catchError, switchMap } from "rxjs/operators";
import { FETCH_LOCALE_BEGIN, fetchLocaleSuccess, logError } from "../actions";
import { updateIntl } from "react-intl-redux";
import { getAjaxSettings } from "../utils/getAjaxSettings";
var flattenMessages = function(nestedMessages) {
    var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return Object.keys(nestedMessages).reduce(function(messages, key) {
        var value = nestedMessages[key];
        var prefixedKey = prefix ? "".concat(prefix, ".").concat(key) : key;
        if (typeof value === "string") {
            messages[prefixedKey] = value;
        } else {
            Object.assign(messages, flattenMessages(value, prefixedKey));
        }
        return messages;
    }, {});
};
var LOCALE_MAP = {
    en_us: "en-US",
    zh_tw: "zh-Hant-TW"
};
var mapLocale = function(locale) {
    return LOCALE_MAP[locale] || locale || "en";
};
export default function fetchLocaleEpic(action$, state$) {
    return action$.pipe(ofType(FETCH_LOCALE_BEGIN), mergeMap(function(action) {
        return ajax(getAjaxSettings("./locales/".concat(action.locale, ".json"), state$.value)).pipe(switchMap(function(param) {
            var response = param.response;
            var locale = mapLocale(response.locale);
            document.querySelector("html").setAttribute("lang", locale || "en");
            return [
                updateIntl({
                    formats: response.formats,
                    locale: locale,
                    messages: flattenMessages(response.messages)
                }),
                fetchLocaleSuccess()
            ];
        }), catchError(function(error) {
            return of(logError({
                error: error,
                key: "fetch_locale"
            }));
        }));
    }), catchError(function(error) {
        return of(logError({
            error: error,
            key: "fetch_locale"
        }));
    }));
}
